<template>
  <div class="home">
   <AppNavbar/>
   <HeroBanner/>
   <SobreNosotros/>
   <NuestrosServicios/>
   <ContacTanos/>
   <AppFooter/>
  </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar.vue';
import HeroBanner from '@/components/HeroBanner.vue';
import SobreNosotros from '@/components/SobreNosotros.vue';
import NuestrosServicios from '@/components/NuestrosServicios.vue';
import ContacTanos from '@/components/ContacTanos.vue';
import AppFooter from '@/components/AppFooter.vue';
export default {
  name: 'HomeView',
  components: {
    AppNavbar,
    HeroBanner,
    SobreNosotros,
    NuestrosServicios,
    ContacTanos,
    AppFooter
  }
}
</script>
